/* FORGE — small dependency-free interactions, ported from the approved mocks.
   Guards: prefers-reduced-motion respected everywhere; hero animations "settle"
   after 1.4s so late scrollers never see half-played states. */
(function () {
  'use strict';
  /* html.forge-motion-off = the visitor pressed the footer's "Pause motion" (set before paint in
     layout/theme.liquid). Treated exactly like prefers-reduced-motion everywhere below. */
  var motionOff = document.documentElement.classList.contains('forge-motion-off');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches || motionOff;

  /* ================= MOTION SWITCH (ACCESSIBILITY_RECHECK R4, WCAG 2.2.2, 2026-10-20) =========
     Footer button. Pausing stops every video at once, then reloads so the canvases and
     observers start in their reduced-motion path; playing just clears the flag and reloads.
     A reload keeps this tiny and reuses the reduced-motion code that already exists. */
  var motionBtn = document.querySelector('[data-forge-motion]');
  if (motionBtn) {
    motionBtn.textContent = motionOff ? 'Play motion' : 'Pause motion';
    motionBtn.hidden = false;
    motionBtn.addEventListener('click', function () {
      try { localStorage.setItem('forge-motion', motionOff ? 'on' : 'off'); } catch (e) {}
      if (!motionOff) {
        document.documentElement.classList.add('forge-motion-off');
        document.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
      }
      window.location.reload();
    });
  }

  /* settle guard — after intro animations finish, pin final states */
  setTimeout(function () { document.body.classList.add('forge-settled'); }, 1400);

  /* ================= PHOENIX RHYTHM GUARD =================
     Brandon, 2026-08-16, on his phone: "down here we have double background stoic logos
     stacked... I'd like to see these stoic logo backgrounds more evenly dispersed."

     The rule this enforces is in forge.css under "Phoenix background watermark": NO TWO
     WATERMARKS WITHIN ONE VIEWPORT HEIGHT of each other, centre to centre in document space.
     It exists because the rule had been written down twice already and broken twice anyway —
     once by a section being inserted between two marked bands, once by a band rendering a
     hand-rolled <img> that no rule could see. A comment cannot stop either of those. This
     can: it measures the real rendered page and hides the second of any colliding pair, so
     the mistake is impossible to ship even when someone makes it.

     WHY HIDING IS SAFE: every .forge-phx-bg is position:absolute, aria-hidden, alt="",
     pointer-events:none and 4.5% opaque. Removing one moves no layout, changes no reading
     order and loses no information. No-JS pages keep the authored placement, which is
     correct by construction today — this only ever engages after someone changes something.

     WHY IT IS NOT SILENT: it console.warns, and inside the theme editor it outlines the
     offending band and labels it, so whoever caused the collision sees it while they are
     making it rather than reading about it in a screenshot from Brandon two days later. */
  var PHX_MIN_GAP = function () {
    /* One phone screen, exactly — the unit Brandon judges in, and the literal statement of
       the complaint ("double background stoic logos stacked" = two marks he could see at
       once). The 640 floor keeps a landscape phone or a short desktop window from suppressing
       half the page. */
    return Math.max(640, window.innerHeight);
  };
  function forgePhxRhythm() {
    var marks = Array.prototype.slice.call(document.querySelectorAll('.forge-phx-bg'));
    if (marks.length < 2) { return; }
    /* Reset first — a hidden element measures 0x0, so a stale suppression from a narrower
       viewport would corrupt the next pass. */
    marks.forEach(function (m) { m.style.display = ''; m.removeAttribute('data-phx-suppressed'); });
    var gap = PHX_MIN_GAP(), scrolled = window.scrollY || window.pageYOffset || 0;
    var seen = marks.map(function (m) {
      var r = m.getBoundingClientRect();
      return { el: m, c: r.top + scrolled + r.height / 2 };
    }).sort(function (a, b) { return a.c - b.c; });
    var last = null, clashes = [];
    seen.forEach(function (o) {
      if (last !== null && (o.c - last) < gap) {
        o.el.style.display = 'none';
        o.el.setAttribute('data-phx-suppressed', Math.round(o.c - last) + 'px');
        clashes.push(o);
        return;                       /* `last` deliberately unchanged: a suppressed mark is
                                         not on the page, so it cannot space the next one. */
      }
      last = o.c;
    });
    if (!clashes.length) { return; }
    var detail = clashes.map(function (o) {
      return (o.el.parentElement && (o.el.parentElement.className || o.el.parentElement.id)) || '?';
    });
    window.console && console.warn(
      '[forge] phoenix rhythm: ' + clashes.length + ' watermark(s) hidden — less than ' +
      Math.round(gap) + 'px from the mark above. Hosts: ' + detail.join(', ') +
      '. See forge.css "Phoenix background watermark".');
    if (window.Shopify && window.Shopify.designMode) {
      clashes.forEach(function (o) {
        var host = o.el.parentElement; if (!host) { return; }
        host.style.outline = '2px dashed #ff4d2e';
        host.style.outlineOffset = '-2px';
        if (host.querySelector('[data-phx-warn]')) { return; }
        var tag = document.createElement('div');
        tag.setAttribute('data-phx-warn', '');
        tag.textContent = 'Phoenix watermark hidden — too close to the mark above (needs ' +
          Math.round(gap) + 'px of scroll between them).';
        tag.style.cssText = 'position:absolute;top:0;left:0;z-index:99;background:#ff4d2e;' +
          'color:#160a05;font:600 11px/1.4 system-ui,sans-serif;padding:4px 8px;max-width:100%;';
        host.appendChild(tag);
      });
    }
  }
  var phxT;
  function forgePhxSoon() { window.clearTimeout(phxT); phxT = window.setTimeout(forgePhxRhythm, 200); }
  forgePhxRhythm();
  window.addEventListener('load', forgePhxSoon);
  window.addEventListener('resize', forgePhxSoon);   /* the threshold is viewport-dependent */
  /* RE-MEASURE WHEN THE PAGE GROWS. This is not belt-and-braces, it is required, and it was
     caught by the guard misfiring on a real product page: the first pass runs before the
     third-party review widget hydrates, at which point the reviews section is ~200px instead
     of ~1,950px, so the guarantee mark measured 467px below the quote mark and was hidden —
     a correct mark, suppressed by a measurement taken too early. Once the widget lands the
     real gap is over 2,000px. Any late content (widget, lazy image, expanded accordion,
     opened FAQ) moves marks, so the guard has to re-run on layout change rather than only at
     two fixed moments. Suppressing a mark cannot itself change layout — every one of them is
     position:absolute — so there is no feedback loop to worry about. */
  if ('ResizeObserver' in window) { new ResizeObserver(forgePhxSoon).observe(document.body); }
  else { window.setTimeout(forgePhxRhythm, 1500); window.setTimeout(forgePhxRhythm, 4000); }

  /* ----- merchant rich-text tables: give every one its own horizontal scroller -----
     forge.css restyles .rte tables to the dark system, but a 3-column comparison table
     still cannot compress below ~340px. Some store pages wrap their table in a
     `<div style="overflow-x:auto">` and some do not, so the page could overflow at 375px
     depending on which page you landed on. This normalises it: any .rte table that is not
     already inside a scroller gets one. Progressive enhancement only — the CSS above
     keeps the table LEGIBLE with or without this. */
  var RTE_TABLES = '.rte table, .forge-desc table, .forge-faq .a table, .shopify-policy__body table';
  Array.prototype.forEach.call(document.querySelectorAll(RTE_TABLES), function (table) {
    if (table.closest('.forge-tablewrap')) { return; }
    var parent = table.parentElement;
    if (parent && parent !== table && /auto|scroll/.test(getComputedStyle(parent).overflowX)) {
      parent.classList.add('forge-tablewrap');
      return;
    }
    var wrap = document.createElement('div');
    wrap.className = 'forge-tablewrap';
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('role', 'region');
    var cap = table.querySelector('caption');
    wrap.setAttribute('aria-label', (cap && cap.textContent.trim()) || 'Table, scrolls horizontally');
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  /* ----- product recommendations: a fallback trigger -----
     Dawn's <product-recommendations> only fetches when an IntersectionObserver fires on it,
     and the element renders EMPTY until that fetch returns. A zero-area target is not
     reliably reported as intersecting, so the element could sit at 0px forever and the
     "Pairs with" row would silently never appear on any product without curated blocks —
     which, on this store, is most of the catalogue. forge.css gives it a 1px floor; this is
     the second, independent guard, because a cross-sell row that depends on one browser's
     zero-area intersection semantics is not a cross-sell row you can count on.
     Fires once, on the first scroll or after the page settles, whichever comes first, and
     only if the element is still empty. */
  (function () {
    var recs = document.querySelectorAll('product-recommendations');
    if (!recs.length) { return; }
    var done = false;
    function kick() {
      if (done) { return; }
      done = true;
      window.removeEventListener('scroll', kick);
      Array.prototype.forEach.call(recs, function (el) {
        if (el.innerHTML.trim()) { return; }
        if (typeof el.loadRecommendations === 'function') {
          el.loadRecommendations(el.dataset.productId);
        }
      });
    }
    window.addEventListener('scroll', kick, { passive: true, once: true });
    setTimeout(kick, 2500);
  })();

  /* sticky header border on scroll */
  var hdr = document.querySelector('.forge-header');
  if (hdr) {
    window.addEventListener('scroll', function () {
      hdr.classList.toggle('scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  /* menu overlay — focus-trapped dialog, closes on Esc (WCAG 2.1.2 / 2.4.3) */
  var nav = document.getElementById('forge-nav');
  var navOpener = null;
  /* aria-expanded is flipped alongside the class (accessibility audit, 2026-08-17). The
     button controls a full-screen overlay but never announced its state, so a screen-reader
     user pressing MENU got no confirmation anything had happened. Set in BOTH functions
     rather than only on click, so Esc and the close button keep it truthful too. */
  function setNavExpanded(v) {
    document.querySelectorAll('[data-forge-nav-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', v ? 'true' : 'false');
    });
  }
  function openNav() {
    if (!nav) { return; }
    nav.classList.add('open');
    setNavExpanded(true);
    navOpener = document.activeElement;
    var closeBtn = nav.querySelector('[data-forge-nav-close]');
    if (closeBtn) { closeBtn.focus(); }
  }
  function closeNav() {
    if (!nav) { return; }
    nav.classList.remove('open');
    setNavExpanded(false);
    if (navOpener && navOpener.focus) { navOpener.focus(); }
  }
  document.querySelectorAll('[data-forge-nav-open]').forEach(function (b) {
    b.addEventListener('click', openNav);
  });
  document.querySelectorAll('[data-forge-nav-close]').forEach(function (b) {
    b.addEventListener('click', closeNav);
  });
  if (nav) {
    nav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeNav(); return; }
      if (e.key !== 'Tab') { return; }
      var focusables = nav.querySelectorAll('a[href], button:not([disabled])');
      if (!focusables.length) { return; }
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* Motion policy: decorative autoplay loops are paused (poster frame stays visible)
     when the visitor asks for reduced motion, and paused while offscreen to save power. */
  var loops = document.querySelectorAll('[data-forge-video]');
  if (loops.length) {
    if (reduced) {
      loops.forEach(function (v) {
        v.autoplay = false;
        try { v.pause(); v.removeAttribute('autoplay'); } catch (e) {}
      });
    } else if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) { pr.catch(function () {}); } }
          else { try { v.pause(); } catch (err) {} }
        });
      }, { rootMargin: '100px' });
      loops.forEach(function (v) { vio.observe(v); });
    }

    /* BREAKPOINT LANES (hero 4:5 mobile vs 16:9 desktop — see forge-video.liquid's
       observer_only). Those two <video>s ship WITHOUT the autoplay attribute, because a
       display:none video that still carries autoplay downloads the whole file anyway
       (measured 2026-08-16: 203,135 bytes for the lane nobody can see). Dropping the
       attribute costs the hidden lane nothing — but it also means the VISIBLE lane has
       nothing starting it except the observer, and the hero is the worst element on the
       site to leave on a single point of failure. So start the displayed lane here too,
       and re-check on resize, which is when a lane flip happens (rotate, or a desktop
       window dragged across 900px). Anything still carrying autoplay is left alone. */
    /* EVERY no-autoplay video now starts (and stops) on a real IntersectionObserver
       (2026-08-19). This block used to serve only the two hero lanes, starting them once at
       load and again on resize — which was correct for elements at the top of the page and
       useless for anything below the fold. That did not matter until the department videos
       dropped their autoplay attribute: measured in lab, `autoplay` forces the FULL download
       of every clip regardless of preload="none" or visibility, and seven force-loaded
       videos (7.2 MB of a 9.7 MB homepage) starved the hero LCP to ~50 s on mobile. Now a
       clip fetches nothing until it approaches the viewport, plays while visible, and
       pauses when it leaves. The IO also covers the old lane-flip case for free: a
       display:none lane never intersects, and a resize that reveals it fires the observer
       without a resize listener. */
    if (!reduced) {
      var lazyVids = [].filter.call(loops, function (v) { return !v.hasAttribute('autoplay'); });
      if (lazyVids.length && 'IntersectionObserver' in window) {
        var vidIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) {
              if (v.offsetParent === null) return;             // hidden lane stays unfetched
              var pr = v.play();
              if (pr && pr.catch) { pr.catch(function () {}); }
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { rootMargin: '25% 0px' });
        lazyVids.forEach(function (v) { vidIO.observe(v); });
      } else if (lazyVids.length) {
        /* No IO (ancient browser): fall back to starting everything, which is just the old
           autoplay behaviour — heavier, never broken. */
        lazyVids.forEach(function (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); });
      }
    }
  }

  /* live header cart count — rides Dawn's pub/sub cart events when present.

     2026-08-17: this block had never once run. The guard asked for window.PUB_SUB_EVENTS,
     but assets/pubsub.js declares PUB_SUB_EVENTS with `const`, and a top-level const is a
     script-scope binding that is never mirrored onto window — only the sibling `function`
     declarations (publish, subscribe) are, which is why those two halves of the same test
     disagreed. window.PUB_SUB_EVENTS read undefined on every page, the subscribe never
     happened, and the header count only ever changed on a full page load. Read the binding
     directly, keeping the window path as the fallback. */
  var cartBus = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
  var countEls = document.querySelectorAll('[data-forge-cart-count]');
  if (countEls.length && typeof window.subscribe === 'function' && cartBus && cartBus.cartUpdate) {
    window.subscribe(cartBus.cartUpdate, function (ev) {
      var count = ev && ev.cartData && typeof ev.cartData.item_count !== 'undefined'
        ? ev.cartData.item_count
        : null;
      if (count === null) { return; }
      countEls.forEach(function (el) { el.textContent = count; });
    });
  }

  /* scroll reveals — pre-mark everything already in the viewport as revealed, THEN
     enable the hidden state (html.forge-js), so nothing visible ever flashes out. */
  var vh = window.innerHeight || 800;
  document.querySelectorAll('.forge-rv, .forge-dept').forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) { el.classList.add('in'); }
  });
  document.documentElement.classList.add('forge-js');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.forge-rv').forEach(function (el) { io.observe(el); });

    var dio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); dio.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    document.querySelectorAll('.forge-dept').forEach(function (el) { dio.observe(el); });
  } else {
    document.querySelectorAll('.forge-rv, .forge-dept').forEach(function (el) { el.classList.add('in'); });
  }

  /* hero ember particle canvas */
  var cv = document.getElementById('forge-embers');
  if (cv && !reduced) {
    var ctx = cv.getContext('2d'), W, H, ps = [];
    /* Sync the backing store to the CSS box. Guarded against a zero/!laid-out box so the
       canvas can never lock itself to the 300x150 replaced-element default. */
    var fit = function () {
      var w = cv.clientWidth || cv.parentElement.clientWidth;
      var h = cv.clientHeight || cv.parentElement.clientHeight;
      if (!w || !h) { return false; }
      W = cv.width = w; H = cv.height = h; return true;
    };
    if (!fit()) { window.requestAnimationFrame(fit); }
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    /* Seed in the LOWER band (0.75 -> 1.25 of canvas height) so embers rise INTO frame
       from the bottom edge instead of popping into existence mid-hero on first paint.
       Recycle stays y < -0.02 -> y = 1.02, so the steady state matches the seed state. */
    /* COUNT AND SPACING, 2026-08-16. Brandon: "Keep the rising embers and stuff. Although
       make them more space." 34 particles in a 393x491 box read as a swarm; 18 reads as
       embers. Seeded across a taller band (0.75 -> 1.65) so the vertical gaps are larger and
       two never arrive together, and the speed range is widened so they de-sync instead of
       drifting as a sheet. */
    for (var i = 0; i < 18; i++) {
      ps.push({ x: Math.random(), y: 0.75 + Math.random() * 0.9, r: 0.6 + Math.random() * 1.7,
        s: 0.10 + Math.random() * 0.42, w: Math.random() * 6.28, o: 0.25 + Math.random() * 0.5 });
    }
    /* perf: only animate while the hero is on screen and the tab is visible */
    var embersActive = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { embersActive = e.isIntersecting; });
      }).observe(cv);
    }
    (function tick() {
      if (!embersActive || document.hidden) { window.setTimeout(tick, 250); return; }
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < ps.length; i++) {
        var p = ps[i];
        /* dy is normalized-by-H so pixel speed stays constant across viewport heights:
           ~26-90 px/sec upward, which reads as rising sparks rather than drifting dust. */
        p.y -= p.s / H * 3.6; p.w += 0.02; p.x += Math.sin(p.w) * 0.0006;
        if (p.y < -0.02) { p.y = 1.02; p.x = Math.random(); }
        var g = ctx.createRadialGradient(p.x * W, p.y * H, 0, p.x * W, p.y * H, p.r * 3);
        g.addColorStop(0, 'rgba(255,140,40,' + p.o + ')');
        g.addColorStop(1, 'rgba(255,140,40,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x * W, p.y * H, p.r * 3, 0, 6.28); ctx.fill();
      }
      window.requestAnimationFrame(tick);
    })();
  }

  /* magnetic primary CTA (fine pointers only) */
  var mag = document.querySelector('[data-forge-magnet]');
  if (mag && window.matchMedia('(pointer:fine)').matches && !reduced) {
    mag.addEventListener('mousemove', function (e) {
      var b = mag.getBoundingClientRect();
      mag.style.transform = 'translate(' + (e.clientX - b.left - b.width / 2) * 0.18 + 'px,' +
        (e.clientY - b.top - b.height / 2) * 0.3 + 'px)';
    });
    mag.addEventListener('mouseleave', function () { mag.style.transform = ''; });
  }

  /* animated proof counter — target comes from data-forge-count (real number, set in section settings) */
  document.querySelectorAll('[data-forge-count]').forEach(function (cnt) {
    var target = parseInt(cnt.getAttribute('data-forge-count'), 10);
    if (!target) { return; }
    var suffix = cnt.getAttribute('data-forge-count-suffix') || '';
    if (reduced || !('IntersectionObserver' in window)) {
      cnt.textContent = target.toLocaleString() + suffix; return;
    }
    /* The markup now ships the REAL number so no-JS/crawler views never show "0 total
       reviews". Zero it here, at the point we know the animation will actually run. */
    cnt.textContent = '0';
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        cio.disconnect();
        var t0 = null;
        window.requestAnimationFrame(function step(ts) {
          if (!t0) { t0 = ts; }
          var p = Math.min(1, (ts - t0) / 1400); p = 1 - Math.pow(1 - p, 3);
          cnt.textContent = Math.round(target * p).toLocaleString() + (p === 1 ? suffix : '');
          if (p < 1) { window.requestAnimationFrame(step); }
        });
      });
    });
    cio.observe(cnt);
  });

  /* phoenix ember convergence over the story band */
  var band = document.getElementById('forge-storyband');
  var pcv = document.getElementById('forge-phoenix-cv');
  if (band && pcv && !reduced) {
    var logoSrc = pcv.getAttribute('data-logo-src');
    if (logoSrc) {
      var logo = new Image();
      logo.crossOrigin = 'anonymous';
      logo.src = logoSrc;
      logo.onload = function () {
        var pio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) { return; }
            pio.disconnect();
            var ctx2 = pcv.getContext('2d');
            var W2 = pcv.width = band.clientWidth, H2 = pcv.height = band.clientHeight;
            var oc = document.createElement('canvas'); var sc = 140;
            oc.width = sc; oc.height = Math.round(sc * logo.height / logo.width);
            var octx = oc.getContext('2d'); octx.drawImage(logo, 0, 0, oc.width, oc.height);
            var data;
            try { data = octx.getImageData(0, 0, oc.width, oc.height).data; }
            catch (err) { return; } /* canvas tainted (CORS) — skip the effect gracefully */
            var pts = [];
            for (var y = 0; y < oc.height; y += 2) {
              for (var x = 0; x < oc.width; x += 2) {
                if (data[(y * oc.width + x) * 4 + 3] > 128) { pts.push([x / oc.width, y / oc.height]); }
              }
            }
            if (!pts.length) { return; }
            /* PLACEMENT, 2026-08-16. Brandon, looking at the draft on his phone: "the orange
               embers are a little misplaced perhaps" — in his screenshot they erupt from the
               bottom-right across the copy.
               Two things were wrong and both are fixed. The canvas painted at z-index:3, i.e.
               ON TOP of the headline, the paragraph and the video (now -1, see forge.css);
               and the phoenix assembled at 70% width / VERTICAL CENTRE of the band — dead
               over the paragraph and the "our story" link, and in a different place from the
               static watermark this band used to carry, so the band drew the mark twice in
               two positions. The static one is gone, and the convergence now lands in the
               footprint it vacated: TOP-RIGHT, inset from the edge, above the lifestyle loop.
                 x  0.03W in from the right edge, ~46% of the band's width
                 y  starts at 7% of the band height
               At 393x676 that is x 200-381, y 47-229 — clear of the loop (which starts at
               338) at every viewport, because both bounds are fractions of the band. */
            var scale = Math.min(W2 * 0.46, H2 * 0.40 * (oc.width / oc.height));
            var offx = W2 - scale - W2 * 0.03, offy = H2 * 0.07;
            /* SEEDING — measured, not guessed. Particles used to start across the FULL width
               at the very bottom of the band and fly the whole thing, which is what made the
               effect read as a graphic sweeping over the text.
               They now start in the band's LOWER 55-95%, which at 393x852 is y 372-642: that
               is inside and below the lifestyle loop (which runs 338-578). With the canvas at
               z-index:-1 the loop is opaque and in front, so the first second of the animation
               is not visible at all — the embers appear to rise OUT from behind the footage
               and up into the top-right, instead of bursting into existence on top of the
               paragraph. Seeding them just under the target shape instead put the whole seed
               frame at y 228-418, i.e. straight over the copy and the "our story" link, which
               is the very thing being fixed here — measured on the draft, not assumed.
               x is biased right so the flight stays in the quadrant the mark forms in.
               `d` staggers each particle by up to 0.55s so they drift into shape instead of
               snapping as one sheet. */
            var N = 240, parts = [];
            for (var i = 0; i < N; i++) {
              var p = pts[Math.floor(Math.random() * pts.length)];
              parts.push({ x: (0.42 + Math.random() * 0.62) * W2,
                y: (0.55 + Math.random() * 0.4) * H2,
                tx: offx + p[0] * scale, ty: offy + p[1] * scale,
                d: Math.random() * 0.55,
                /* Alpha ceiling drops from 0.9 to 0.6 and the spark radius from 3.2 to 2.6:
                   ambient embers, not a lit graphic. */
                o: 0.18 + Math.random() * 0.42 });
            }
            var t0 = null;
            window.requestAnimationFrame(function step(ts) {
              if (!t0) { t0 = ts; }
              var el = (ts - t0) / 1000;
              ctx2.clearRect(0, 0, W2, H2);
              /* Hold longer and fade slower than the old 4.5s/1.2s — a quick cut read as the
                 graphic being switched off. */
              var fade = el > 5 ? Math.max(0, 1 - (el - 5) / 2) : 1;
              for (var i = 0; i < N; i++) {
                var p = parts[i];
                var f = Math.min(1, Math.max(0, el - p.d) / 2.2); f = 1 - Math.pow(1 - f, 3);
                var cx = p.x + (p.tx - p.x) * f, cy = p.y + (p.ty - p.y) * f;
                var g = ctx2.createRadialGradient(cx, cy, 0, cx, cy, 2.6);
                g.addColorStop(0, 'rgba(237,138,69,' + (p.o * fade) + ')');
                g.addColorStop(1, 'rgba(237,138,69,0)');
                ctx2.fillStyle = g; ctx2.beginPath(); ctx2.arc(cx, cy, 2.6, 0, 6.28); ctx2.fill();
              }
              if (el < 7.4) { window.requestAnimationFrame(step); }
              else { ctx2.clearRect(0, 0, W2, H2); }
            });
          });
        }, { threshold: 0.45 });
        pio.observe(band);
      };
    }
  }
})();
